import { Component, Input } from '@angular/core';
import { ScansInterface } from '@monsido/modules/models/api/interfaces/scans.interface';

@Component({
    selector: 'mon-request-checker-response-headers-component',
    templateUrl: 'response-headers.html',
    styleUrls: ['./../../request-checker.scss'],
    standalone: false,
})

export class ResponseHeadersComponent {
    @Input() url: string;
    @Input() scan: ScansInterface;
    constructor () {}
}
